<template>
  <div>
    <div class="title">
      <p v-text-lbl="'hygl.voteManage.votoTitle'" :voteTheme="row.voteTheme"> 投票主题: {{ row.voteTheme }}</p>
      <p v-text-lbl="'hygl.voteManage.deadline'" :endTime="row.endTime"> 截止时间： {{ row.endTime }}</p>
    </div>
    <div class="content">
      <img :src="qrCodeSrc" alt="" style="display:block">
      <p v-text-lbl="'hygl.voteManage.votoScan'"> 手机扫描二维码投票 </p>
    </div>
  </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        row: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            qrCodeSrc: '',
            loginUser: this.$store.getters.loginUser
        }
    },
    computed: {

    },
    created() {
        console.log('loginUser', this.loginUser)
    },
    beforeDestroy() {

    },
    mounted() {
        this.getQrCode()
    },
    methods: {
        getQrCode() {
            const { id } = this.row
            console.log('this.row', this.row)
            const host = location.href.split('#')[0] + 'mindex.html'
            // http://localhost:9530/mindex.html#/toHyVote?id=797af3bb0d884d31a4c2b749e254a316&account=huangduo&orgCode=tsys&canEdit=0&choiceStatus=2
            let canEdit = 0
            if (this.row.voteStatus != 3 && this.row.passenger.choiceStatus == 1) {
                canEdit = 1
            }
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: 'homepage/createUrlQrCode',
                params: {
                    url: `${host}#/toHyVote?id=${id}&account=${this.loginUser.personAccount}&orgCode=${this.loginUser.orgCode}&canEdit=${canEdit}&choiceStatus=2&isFullScreen=true`
                    // url: `http://192.168.1.230:9530/mindex.html#/toHyVote?id=${id}&account=${this.loginUser.personAccount}&orgCode=${this.loginUser.orgCode}&canEdit=${canEdit}&choiceStatus=2&isFullScreen=true`
                }
            }).then(res => {
                if (res.code === 'success') {
                    this.qrCodeSrc = 'data:image/png;base64,' + res.body.image
                    this.$emit('getQrCodeSrc', this.qrCodeSrc)
                    this.$forceUpdate()
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.content {
  img {
    width: 250px;
    height: 250px;
    display: block;
    margin: 0 auto;
  }
  p {
    text-align: center;
  }
}
</style>
